export enum TransactionTypeEnum {
  Terminal = 1,
  Keyed = 2,
  Legacy = 3
}
